var segmentlyLibraries = function($) {
  +function ($) { "use strict";

    // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
    // ============================================================

    function segmentlyTransitionEnd() {
      var el = document.createElement('segmently-bootstrap')

      var segmentlyTransEndEventNames = {
        'WebkitTransition' : 'webkitTransitionEnd'
        , 'MozTransition'    : 'transitionend'
        , 'OTransition'      : 'oTransitionEnd otransitionend'
        , 'transition'       : 'transitionend'
      }

      for (var name in segmentlyTransEndEventNames) {
        if (el.style[name] !== undefined) {
          return { end: segmentlyTransEndEventNames[name] }
        }
      }
    }

    // http://blog.alexmaccaw.com/css-transitions
    $.fn.segmentlyEmulateTransitionEnd = function (duration) {
      var called = false, $el = this
      $(this).one($.support.segmentlyTransition.end, function () { called = true })
      var callback = function () { if (!called) $($el).trigger($.support.segmentlyTransition.end) }
      setTimeout(callback, duration)
      return this
    }

    $(function () {
      $.support.segmentlyTransition = segmentlyTransitionEnd()
    })

  }($);


  /* ==================================
   * SocialShopWave: segmently-modal.js
   * ================================== */


  +function ($) { "use strict";

    // MODAL CLASS DEFINITION
    // ======================

    var SegmentlyModal = function (element, options) {
      this.options   = options
      this.$element  = $(element)
      this.$backdrop =
        this.isShown   = null

      if (this.options.remote) this.$element.load(this.options.remote)
    }

    SegmentlyModal.DEFAULTS = {
      backdrop: true
      , keyboard: true
      , show: true
    }

    SegmentlyModal.prototype.toggle = function (_relatedTarget) {
      return this[!this.isShown ? 'show' : 'hide'](_relatedTarget)
    }

    SegmentlyModal.prototype.show = function (_relatedTarget) {
      var that = this

      var e    = $.Event('show.segmently.modal', { relatedTarget: _relatedTarget })

      if(typeof communityActive !== 'undefined' && communityActive){
        this.$element.appendTo('#segmently-community-box > .segmently-community-body')
      }else{
        if(this.$backdrop){
          this.$backdrop.appendTo(document.body);
        }
        if($('#site-body').length){
          this.$element.appendTo('#site-body')
        }else{
          this.$element.appendTo(document.body)
        }
      }
      this.$element.trigger(e)

      if (this.isShown || e.isDefaultPrevented()) return

      this.isShown = true

      this.checkScrollbar()

      if(typeof communityActive !== 'undefined' && communityActive){
        $('#segmently-community-box > .segmently-community-body').addClass('segmently-modal-open')
      }else{
        $('html').addClass('segmently-modal-open');
      }

      this.setScrollbar()

      this.escape()

      this.$element.on('click.dismiss.segmently-modal', '[data-dismiss="segmently-modal"]', $.proxy(this.hide, this))

      this.backdrop(function () {
        var segmentlyTransition = $.support.segmentlyTransition && that.$element.hasClass('segmently-fade')
        if (!that.$element.parent().length) {
          that.$element.appendTo(document.body) // don't move modals dom position
        }

        that.$element.show()

        if (segmentlyTransition) {
          that.$element[0].offsetWidth // force reflow
        }

        that.$element
          .addClass('segmently-in')
          .attr('aria-hidden', false)

        that.enforceFocus()

        var e = $.Event('shown.segmently.modal', { relatedTarget: _relatedTarget })

        segmentlyTransition ?
          that.$element.find('.segmently-modal-dialog') // wait for modal to slide in
            .one($.support.segmentlyTransition.end, function () {
              that.$element.focus().trigger(e)
            })
            .segmentlyEmulateTransitionEnd(300) :
          that.$element.focus().trigger(e)
      })
    }

    SegmentlyModal.prototype.hide = function (e) {
      if (e) e.preventDefault()

      e = $.Event('hide.segmently.modal')

      this.$element.trigger(e)

      if (!this.isShown || e.isDefaultPrevented()) return

      this.isShown = false

      if ($('.segmently-modal.segmently-in').length == 1) {
        $('html').removeClass('segmently-modal-open');
        this.resetScrollbar();
      }

      this.escape()

      $(document).off('focusin.segmently.modal')

      this.$element
        .removeClass('segmently-in')
        .attr('aria-hidden', true)
        .off('click.dismiss.segmently-modal')

      $.support.segmentlyTransition && this.$element.hasClass('segmently-fade') ?
        this.$element
          .one($.support.segmentlyTransition.end, $.proxy(this.hideModal, this))
          .segmentlyEmulateTransitionEnd(300) :
        this.hideModal()
    }

    SegmentlyModal.prototype.enforceFocus = function () {
      $(document)
        .off('focusin.segmently.modal') // guard against infinite focus loop
        .on('focusin.segmently.modal', $.proxy(function (e) {
          if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
            this.$element.focus()
          }
        }, this))
    }

    SegmentlyModal.prototype.escape = function () {
      if (this.isShown && this.options.keyboard) {
        this.$element.on('keyup.dismiss.segmently.modal', $.proxy(function (e) {
          e.which == 27 && this.hide()
        }, this))
      } else if (!this.isShown) {
        this.$element.off('keyup.dismiss.segmently.modal')
      }
    }

    SegmentlyModal.prototype.hideModal = function () {
      var that = this
      this.$element.hide()
      this.backdrop(function () {
        that.removeBackdrop()
        that.$element.trigger('hidden.segmently.modal')
      })
    }

    SegmentlyModal.prototype.removeBackdrop = function () {
      this.$backdrop && this.$backdrop.remove()
      this.$backdrop = null
    }

    SegmentlyModal.prototype.backdrop = function (callback) {
      var that    = this
      var animate = this.$element.hasClass('segmently-fade') ? 'segmently-fade' : ''

      if (this.isShown && this.options.backdrop) {
        var doAnimate = $.support.segmentlyTransition && animate

        if(typeof communityActive !== 'undefined' && communityActive){
          this.$backdrop = $('<div class="segmently-modal-backdrop ' + animate + '" />')
            .appendTo('#segmently-community-box > .segmently-community-body')
        }else{
          this.$backdrop = $('<div class="segmently-modal-backdrop ' + animate + '" />')
            .appendTo(document.body)
        }
        this.$element.on('click.dismiss.segmently-modal', $.proxy(function (e) {
          if (e.target !== e.currentTarget) return
          this.options.backdrop == 'static'
            ? this.$element[0].focus.call(this.$element[0])
            : this.hide.call(this)
        }, this))

        if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

        this.$backdrop.addClass('segmently-in')

        if (!callback) return

        doAnimate ?
          this.$backdrop
            .one($.support.segmentlyTransition.end, callback)
            .segmentlyEmulateTransitionEnd(150) :
          callback()

      } else if (!this.isShown && this.$backdrop) {
        this.$backdrop.removeClass('segmently-in')

        $.support.segmentlyTransition && this.$element.hasClass('segmently-fade')?
          this.$backdrop
            .one($.support.segmentlyTransition.end, callback)
            .segmentlyEmulateTransitionEnd(150) :
          callback()

      } else if (callback) {
        callback()
      }
    }

    SegmentlyModal.prototype.checkScrollbar = function () {
      if (document.body.clientWidth >= window.innerWidth) return
      this.scrollbarWidth = this.scrollbarWidth || this.measureScrollbar()
    }

    SegmentlyModal.prototype.setScrollbar = function () {
      if(typeof communityActive === 'undefined' || (typeof communityActive !== 'undefined' && !communityActive)){
        var bodyPad = parseInt(($('html').css('padding-right') || 0), 10)
        if (this.scrollbarWidth && $('.segmently-modal.segmently-in').length == 0) $('html').css('padding-right', bodyPad + this.scrollbarWidth)
      }
    }

    SegmentlyModal.prototype.resetScrollbar = function () {
      $('html').css('padding-right', '')
    }

    SegmentlyModal.prototype.measureScrollbar = function () { // thx walsh
      var scrollDiv = document.createElement('div')
      scrollDiv.className = 'segmently-modal-scrollbar-measure'
      $(document.body).append(scrollDiv)
      var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      $(document.body)[0].removeChild(scrollDiv)
      return scrollbarWidth
    }

    // MODAL PLUGIN DEFINITION
    // =======================

    var old = $.fn.segmentlyModal

    $.fn.segmentlyModal = function (option, _relatedTarget) {
      return this.each(function () {
        var $this   = $(this)
        var data    = $this.data('segmently.segmently-modal');
        var options = $.extend({}, SegmentlyModal.DEFAULTS, $this.data(), typeof option == 'object' && option)

        if (!data) $this.data('segmently.segmently-modal', (data = new SegmentlyModal(this, options)))
        if (typeof option == 'string') data[option](_relatedTarget)
        else if (options.show) data.show(_relatedTarget)
      })
    }

    $.fn.segmentlyModal.Constructor = SegmentlyModal


    // MODAL NO CONFLICT
    // =================

    $.fn.segmentlyModal.noConflict = function () {
      $.fn.segmentlyModal = old
      return this
    }

    // MODAL DATA-API
    // ==============

    $(document).on('click.segmently.modal.data-api', '[data-toggle="segmently-modal"]', function (e) {
      var $this   = $(this)
      var href    = $this.attr('href')
      var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
      var option  = $target.data('segmently-modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

      e.preventDefault()

      $target
        .segmentlyModal(option, this)
        .one('hide', function () {
          $this.is(':visible') && $this.focus()
        })
    })

    /*$(document)
     .on('show.segmently.modal',  '.segmently-modal', function () {
     $('html').addClass('segmently-modal-open'); })
     .on('hidden.segmently.modal', '.segmently-modal', function () {
     if(!$('.segmently-modal').hasClass('segmently-in')){
     $('html').removeClass('segmently-modal-open')
     }
     })*/

  }($);

  /* ==================================
   * SocialShopWave: segmently-alert.js
   * ================================== */


  +function ($) { "use strict";

    // ALERT CLASS DEFINITION
    // ======================

    var segmentlyDismiss = '[data-dismiss="segmently-alert"]'
    var SegmentlyAlert   = function (el) {
      $(el).on('click', segmentlyDismiss, this.close)
    }

    SegmentlyAlert.prototype.close = function (e) {
      var $this    = $(this)
      var selector = $this.attr('data-target')

      if (!selector) {
        selector = $this.attr('href')
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
      }

      var $parent = $(selector)

      if (e) e.preventDefault()

      if (!$parent.length) {
        $parent = $this.hasClass('segmently-alert') ? $this : $this.parent()
      }

      $parent.trigger(e = $.Event('close.segmently.alert'))

      if (e.isDefaultPrevented()) return

      $parent.removeClass('segmently-in')

      function segmentlyRemoveElement() {
        $parent.trigger('closed.segmently.alert').remove()
      }

      $.support.segmentlyTransition && $parent.hasClass('segmently-fade') ?
        $parent
          .one($.support.segmentlyTransition.end, segmentlyRemoveElement)
          .segmentlyEmulateTransitionEnd(150) :
        segmentlyRemoveElement()
    }


    // ALERT PLUGIN DEFINITION
    // =======================

    var old = $.fn.segmentlyAlert

    $.fn.segmentlyAlert = function (option) {
      return this.each(function () {
        var $this = $(this)
        var data  = $this.data('segmently.alert')

        if (!data) $this.data('segmently.alert', (data = new SegmentlyAlert(this)))
        if (typeof option == 'string') data[option].call($this)
      })
    }

    $.fn.segmentlyAlert.Constructor = SegmentlyAlert


    // ALERT NO CONFLICT
    // =================

    $.fn.segmentlyAlert.noConflict = function () {
      $.fn.segmentlyAlert = old
      return this
    }


    // ALERT DATA-API
    // ==============

    $(document).on('click.segmently.alert.data-api', segmentlyDismiss, SegmentlyAlert.prototype.close)

  }($);
}
var loadSegmentlyLibs = setInterval(function(){
  if (typeof segmentlyJqLoaded != 'undefined' && segmentlyJqLoaded) {
    clearInterval(loadSegmentlyLibs);
    segmentlyLibraries(segmently);
  }
}, 10);